import { Text } from 'src/modules/shared/components/atoms/text';
import { DateGroup } from 'src/modules/shared/hooks/tasks/use-task-grouping';
import { TaskItem } from 'src/modules/shared/components/molecules/tasks/task-item';

interface TaskDateGroupProps {
  group: DateGroup;
}

export const TaskDateGroup: React.FC<TaskDateGroupProps> = ({ group }) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Text
          size="small"
          weight="medium"
          className={group.isOverdue ? 'text-danger-600' : 'text-gray-700'}
        >
          {group.label}
        </Text>
        <Text size="small" className="text-gray-500">
          ({group.tasks.length})
        </Text>
      </div>

      <div className="flex flex-col gap-2">
        {group.tasks.map((task) => (
          <TaskItem
            key={task.id}
            task={task}
            showConversationLink={!!task.context?.conversationId}
          />
        ))}
      </div>
    </div>
  );
};
